var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGefionFacility6({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 64,
    viewBox: "0 0 80 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7055 51.8617C42.1108 49.2668 37.8885 49.2668 35.2938 51.8617C32.6989 54.4565 32.6989 58.6787 35.2938 61.2735C36.5911 62.571 38.2955 63.2198 39.9996 63.2198C41.7036 63.2198 43.4082 62.5712 44.7054 61.2735C47.3004 58.6788 47.3004 54.4565 44.7055 51.8617Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5254 40.0994L28.2312 44.8052C34.7184 38.3181 45.2734 38.3181 51.7605 44.8052L56.4663 40.0994C47.3848 31.0177 32.6073 31.0177 23.5254 40.0994Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0029 16.637C29.337 16.637 19.3095 20.7904 11.7676 28.3324L16.4734 33.0382C22.7582 26.7534 31.1146 23.292 40.0027 23.292C48.8909 23.292 57.2473 26.7534 63.5321 33.0382L68.2379 28.3324C60.6963 20.7904 50.6688 16.637 40.0029 16.637Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 0C24.89 0 10.6844 5.88422 0 16.5686L4.70578 21.2744C14.1333 11.847 26.6678 6.65516 40 6.65516C53.3322 6.65516 65.8667 11.847 75.2942 21.2745L80 16.5686C69.3156 5.88422 55.11 0 40 0Z",
    fill: "#C49A36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGefionFacility6);
export default __webpack_public_path__ + "static/media/gefion-facility-6.2a16803b137c40bff20847ee5eb8aa05.svg";
export { ForwardRef as ReactComponent };